import React, { Fragment, useEffect, useRef, useState } from "react";
import { Card, CardBody, Col, Container, FormGroup, Input, Row, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import DateRangePickerDefault from "../../../share-components/ui/DateRangePickerDefault";
import Breadcrumb from "../../../layout/breadcrumb";
import withReducer from "../../../store/withReducer";
import reportReducer from "../index";
import moment from "moment";
import Select, { components } from "react-select";
import AsyncSelect from "react-select/async";
import { mapSearchAutoSuggestion } from "../../../utils/mapper";
import { sellerAutoSuggestionApi, sellerBrandSuggestionApi } from "../../../services/manage-product/productService";
import { getOrderItemReport, exportOrderItemReport } from "./store/orderItemReportSlice";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import {
  formatterDecimal, formatter
} from "../../../utils/common";

import "./styles.scss";

const { afterToday } = DateRangePicker;

const OrderItemReport = (props) => {

  const endDateObj = moment().toDate(); // Today
  const startDateObj = moment().subtract(30, "days").toDate(); // Last 30 days

  const [dateRange, setDateRange] = useState([startDateObj, endDateObj]);
  const safeDateRange = Array.isArray(dateRange) ? dateRange : [null, null];
  const [startDate, endDate] = safeDateRange;

  const authData = useSelector(({ authReducer }) => authReducer);

  const orderNoDebounceRef = useRef(null);
  const sellerDebounceRef = useRef(null);
  const brandDebounceRef = useRef(null);
  const [orderNoInputValue, setOrderNoInputValue] = useState("");
  const [lastFillters, setLastFillters] = useState(null);
  const [fillterSeller, setFillterSeller] = useState(authData && authData.defaultSeller ? authData.defaultSeller : (authData && authData.defaultSellerOption ? authData.defaultSellerOption : ""));
  const [fillterBrand, setFillterBrand] = useState([{ value: 16, label: "Goddiva" }]);
  const brandIds = fillterBrand ? fillterBrand.map((brand) => brand.value) : null;
  const [filter, setFilter] = useState({
    page: 1,
    pageSize: 10,
    start_date: moment(startDate).format("YYYY-MM-DD"),
    end_date: moment(endDate).format("YYYY-MM-DD"),
    sku: "",
    order_no: "",
    seller: fillterSeller ? fillterSeller.value : null,
    brand: brandIds,
    // status: searchStatus?.id,
  });

  const dispatch = useDispatch();
  const currentUser = useSelector(({ authReducer }) => authReducer.data.user);
  const [loading, setLoading] = useState(true);
  const orderItemReportState = useSelector(({ report }) => report.orderItemReport);
  const [exportBtnDisabled, setExportBtnDisabled] = useState(false);

  const dataMenu = [
    {
      type: 0,
      text: "Reports",
    },
    {
      type: 0,
      text: "Order Item Report",
    },
  ];

  const getEffectiveFilter = () => {
    const brandIds = fillterBrand ? fillterBrand.map((brand) => brand.value) : null;
    return {
      ...filter,
      page: filter.page,
      pageSize: filter.pageSize,
      start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
      end_date: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
      seller: fillterSeller ? fillterSeller.value : null,
      brand: brandIds,
      sku: filter.sku,
      order_no: filter.order_no,
      sortBy: filter.sortBy,
      sortOrder: filter.sortOrder,
    };
  };

  const getOrderedItemsData = () => {
    const effectiveFilter = getEffectiveFilter();
    if (JSON.stringify(effectiveFilter) === JSON.stringify(lastFillters)) return;

    setLastFillters({ ...effectiveFilter });
    setLoading(true);

    dispatch(
      getOrderItemReport(effectiveFilter)
    ).then((res) => {
      if (!res.error) {
        setLoading(false);
      }
    }).catch(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    getOrderedItemsData();
  }, [dispatch, filter, startDate, endDate, fillterSeller, fillterBrand]);

  useEffect(() => {
    const brandIds = fillterBrand ? fillterBrand.map((brand) => brand.value) : null;
    setFilter(prev => ({
      ...prev,
      page: 1,
      start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
      end_date: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
      seller: fillterSeller ? fillterSeller.value : null,
      brand: brandIds,
    }));
  }, [startDate, endDate, fillterSeller, fillterBrand]);

  useEffect(() => {
    return () => {
      if (orderNoDebounceRef.current) clearTimeout(orderNoDebounceRef.current);
    };
  }, []);


  const afterToday = () => {
    return (date) => date.getTime() > new Date().getTime();
  };

  const onPageSizeChange = (newPageSize) => {
    setFilter(prev => ({
      ...prev,
      page: 1,
      pageSize: newPageSize === 'All' ? orderItemReportState.tableRow : newPageSize
    }));
  }

  const onPageChange = (e) => {
    setFilter({ ...filter, page: e });
  }

  const handleSort = (column, sortDirection) => {
    const sortBy = column.sortField || column.selector; // Use `sortField` if available
    setFilter(prev => ({
      ...prev,
      sortBy, // Get the column field name
      sortOrder: sortDirection, // 'asc' or 'desc'
    }));
  };

  const exportFile = () => {
    if (exportBtnDisabled) return;
    setExportBtnDisabled(true);

    const brandIds = fillterBrand ? fillterBrand.map((brand) => brand.value) : null;
    const exportFilter = {
      ...filter,
      start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
      end_date: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
      seller: fillterSeller ? fillterSeller.value : null,
      brand: brandIds,
    };

    dispatch(
      exportOrderItemReport(exportFilter)
    ).then((res) => {
      const url = res?.payload;
      if (url) {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
      setExportBtnDisabled(false);
    }).catch(() => {
      setExportBtnDisabled(false);
    });
  };

  const tableColumns = [
    {
      name: "Order No",
      selector: (row) => row.order_name || row.order_no,
      sortable: false,
      sortField: 'order_name',
      left: true,
      grow: 0.2,
      cell: (row) => (
        <Link
          className="text-primary"
          style={{ cursor: "pointer" }}
          to={`${process.env.PUBLIC_URL}/order/${row.order_id}/view`}
          target="_blank"
        >
          {row.order_name || row.order_no || "-"}
        </Link>
      ),
    },
    {
      name: "Order Date",
      selector: (row) => row.order_date,
      sortable: false,
      sortField: 'order_date', // Custom backend field name
      left: true,
      grow: 0.4, // column size
    },
    {
      name: "SKU",
      selector: (row) => row.sku,
      sortable: false,
      sortField: 'sku', // Custom backend field name
      left: true,
      grow: 0.6, // column size
    },
    {
      name: "Current Price",
      selector: (row) => formatter.format(row.current_product_price),
      sortable: false,
      sortField: 'current_product_price', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "Current Sale Price",
      selector: (row) => formatter.format(row.current_product_sale_price),
      sortable: false,
      sortField: 'current_product_sale_price', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "Current Cost",
      selector: (row) => formatter.format(row.current_product_cost),
      sortable: false,
      sortField: 'current_product_cost', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "High Price",
      selector: (row) => formatter.format(row.high_price),
      sortable: false,
      sortField: 'high_price', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "Actual Price",
      selector: (row) => formatter.format(row.actual_product_price),
      sortable: false,
      sortField: 'actual_product_price', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "Actual Sale Price",
      selector: (row) => formatter.format(row.actual_product_sale_price),
      sortable: false,
      sortField: 'actual_product_sale_price', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "Actual Cost",
      selector: (row) => formatter.format(row.actual_product_cost),
      sortable: false,
      sortField: 'actual_product_cost', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "Order Sale Price",
      selector: (row) => formatter.format(row.order_price),
      sortable: false,
      sortField: 'order_price', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
    {
      name: "Order Qty",
      selector: (row) => row.order_qty,
      sortable: false,
      sortField: 'order_qty', // Custom backend field name
      center: true,
      grow: 0.3, // column size
    },
    {
      name: "Currency Rate",
      selector: (row) => (row.currency_rate != null ? Number(row.currency_rate).toFixed(2) : ''),
      sortable: false,
      sortField: 'currency_rate', // Custom backend field name
      right: true,
      grow: 0.3, // column size
    },
  ];

  const sellerPromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
      };
      if (sellerDebounceRef.current) clearTimeout(sellerDebounceRef.current);
      sellerDebounceRef.current = setTimeout(() => {
        resolve(mapSearchAutoSuggestion(sellerAutoSuggestionApi(data)));
      }, 300);
    });

  const brandPromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
        seller_id: filter.seller,
        check_seller_active: true,
      };
      if (brandDebounceRef.current) clearTimeout(brandDebounceRef.current);
      brandDebounceRef.current = setTimeout(() => {
        resolve(mapSearchAutoSuggestion(sellerBrandSuggestionApi(data)));
      }, 300);
    });

  return (
    <Fragment>
      <Breadcrumb title="Order Item Report" data={dataMenu} />
      <Container fluid={true} className="finances-summary-page">
        <div className="product-grid">
          <div className="feature-products">
            <Card className="date-range-export-card px-3 mb-3">
              <CardBody className="date-range-export-row">
                <Row>
                  <Col md="4" className="date-range-col">
                    <FormGroup>
                      <div className="dashboard-datepicker">
                        <DateRangePickerDefault
                          dateRange={dateRange}
                          dateRangeChange={(date) => {
                            setDateRange(date || [null, null]);
                          }}
                          size="md"
                          placeholder="Select start and end date"
                          cleanable={true}
                          defaultValue={[startDateObj, endDateObj]}
                          disabledDate={afterToday()}
                        />
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xs="12" sm="6" md className="report-filter-col">
                    <FormGroup className="report-filter-form-group search-sku-group">
                      <Input
                        className="form-control search-sku-input"
                        type="text"
                        placeholder="Search by Order No"
                        value={orderNoInputValue}
                        onChange={(e) => {
                          const value = e.target.value;
                          setOrderNoInputValue(value);
                          if (orderNoDebounceRef.current) clearTimeout(orderNoDebounceRef.current);
                          orderNoDebounceRef.current = setTimeout(() => {
                            setFilter((prev) => ({ ...prev, page: 1, order_no: value.trim() }));
                          }, 400);
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs="12" sm="6" md className="report-filter-col">
                    <FormGroup className="report-filter-form-group search-sku-group">
                      <Input
                        className="form-control search-sku-input"
                        type="text"
                        placeholder="Search SKU"
                        onChange={(e) => {
                          setFilter((prev) => ({ ...prev, page: 1, sku: e.target.value }));
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  {currentUser.role.name!=="Seller" && (
                    <Col xs="12" sm="6" md="6" className="report-filter-col report-filter-seller-col">
                      <FormGroup className="report-filter-form-group">
                        <AsyncSelect
                          className="select2-filter"
                          isClearable={true}
                          defaultOptions
                          value={fillterSeller}
                          placeholder="Select Seller"
                          loadOptions={sellerPromiseOption}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                          menuPortalTarget={document.body}
                          components={{
                            IndicatorSeparator: () => null,
                            DropdownIndicator: (props) => {
                              return fillterSeller ? null : <components.DropdownIndicator {...props} />;
                            }
                          }}
                          onChange={(e) => {
                            setFillterSeller(e);
                            setFillterBrand([]);
                          }}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  <Col xs="12" sm="6" md={currentUser.role.name==="Seller" ? 12 : 6} className="report-filter-col report-filter-brand-col">
                    <FormGroup className="report-filter-form-group">
                      <AsyncSelect
                        cacheOptions={false}
                        key={filter.seller}
                        className="select2-filter"
                        isClearable={true}
                        isMulti={true}
                        defaultOptions
                        placeholder="Select Brand"
                        loadOptions={brandPromiseOption}
                        value={fillterBrand}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        components={{
                          IndicatorSeparator: () => null,
                          DropdownIndicator: (props) => {
                            return fillterBrand ? null : <components.DropdownIndicator {...props} />;
                          }
                        }}
                        onChange={(e) => {
                          setFillterBrand(e);
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <div className="float-right">
                      <Button
                        type="button"
                        color="primary"
                        size="sm"
                        onClick={() => {
                          exportFile();
                        }}
                        disabled={exportBtnDisabled}
                      >
                        <i className={exportBtnDisabled ? "fa fa-spinner fa-spin mr-1" : "fa fa-download mr-1"}></i>
                        Export Report
                      </Button>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <div className="table-responsive product-table">
                      <CommonDataTable
                        headerColumns={tableColumns}
                        gridData={orderItemReportState.items}
                        noAction
                        progressPending={loading}
                        paginationServer
                        paginationTotalRows={orderItemReportState.tableRow}
                        paginationRowsPerPageOptions={[10, 50, 100, 500, 1000]}
                        paginationDefaultPage={filter.page}
                        paginationPerPage={filter.pageSize}
                        onChangePage={onPageChange}
                        onChangeRowsPerPage={onPageSizeChange}
                        onSort={handleSort}
                        noDataComponent={<div className="p-4 text-center">No Records Found.</div>}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </Fragment>
  );
};

export default withReducer([{ report: reportReducer }])(OrderItemReport);
